import { ClientsideLogger } from "../../../../util/logger/logger"
import { Logger } from '@utils'
import { WebPlayer } from "ATVWebPlayer"
import { playerLoaderConfig, PlayerLoaderConfig } from "./config";

export interface ATVWebPlayer {
  new(): WebPlayer
}

declare global {
  interface Window {
    WebPlayer?: ATVWebPlayer
  }
}

let loadAttempt = 0
let webPlayer: WebPlayer
let initPromise: Promise<WebPlayer>
const deviceLoggerURL = '/gp/video/ajax/log-device-info.html/ref=atv_log_device_info'

// TODO: Investigate alternative loading strategy: https://i.amazon.com/issues/AVWebDetailPage-3453

const loadScript = (source: string, logger: Logger) => new Promise((resolve, reject) => {
  const script: any = document.createElement('script')
  script.type = 'text/javascript'
  script.crossOrigin = 'anonymous'

  if (script.readyState) {  //Internet explorer
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        resolve()
      }
    };
  } else {  //Modern browsers
    script.onload = () => {
      resolve()
    }
  }

  script.src = source;
  script.onerror = () => { reject() }
  script.async = true;
  logger.debug('loading script source', source);
  document.getElementsByTagName('head')[0].appendChild(script);
})

const init = (config: PlayerLoaderConfig, logger: Logger): Promise<WebPlayer> => new Promise((resolve, reject) => {
  const { retryAttempts, retryIntervalMillis, retryExponent, source } = config

  if (webPlayer) {
    resolve(webPlayer)
  }

  const logFatal = (errorType: string) => {
    logger.count(`DVWebPlayer:${errorType}:load:failure`, 1, true)

    if (window.navigator && window.navigator.onLine) {
      logger.fatal(`Failed to load DVWebPlayer ${errorType} script after ${loadAttempt} retries. SRC: ${source}`)
    }

    fetch(`${deviceLoggerURL}?description=DVWebPlayer${errorType}LoadFailed`)
  }

  const onScriptError = (errorType: string) => {
    if (++loadAttempt <= retryAttempts) {
      const delay = retryIntervalMillis + retryIntervalMillis * Math.pow(loadAttempt, retryExponent)
      window.setTimeout(load, delay)
    } else {
      logFatal(errorType)
      reject()
    }
  }

  function onPlayerLoad() {
    if (window.WebPlayer && typeof window.WebPlayer === 'function') {
      logger.debug('Webplayer Loaded succesfully')
      webPlayer = new window.WebPlayer()
      resolve(webPlayer)
    } else {
      onScriptError('Player')
    }
  }

  function load() {
    if (source) {
      loadScript(source, logger).then(onPlayerLoad).catch(onPlayerLoad)
    } else {
      logFatal('SourceMissing')
      reject()
    }
  }

  load()
})

export const loadWebPlayer = (
  config: PlayerLoaderConfig = playerLoaderConfig,
  logger: Logger = new ClientsideLogger('WebPlayerLoader')
) => {

  if (initPromise) {
    return initPromise
  } else {
    initPromise = init(config, logger)
    return initPromise
  }
}
